import { TextButton } from '@creditornot/cb-button';
import { ArrowLeft } from '@creditornot/cb-icons';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  onBackButtonClick: () => void;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  height: 64px;
  padding-inline-start: 34px;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

const StyledTextButton = styled(TextButton)`
  font-weight: bold;
  svg {
    margin-inline-end: 10px;
    width: 15px;
  }
`;

const NavigationBar = ({ onBackButtonClick }: Props) => (
  <Root>
    <StyledTextButton variant="black" size="small" icon={<ArrowLeft />} onClick={onBackButtonClick}>
      <FormattedMessage id="menu.bulk-image.back-to-menu-editor" />
    </StyledTextButton>
  </Root>
);

export default NavigationBar;
